var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "page-wrap",
      attrs: {
        "element-loading-text":
          "Please wait. This might take a while depending on the size and amount of your attachments.",
      },
    },
    [
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c("el-col", [
                _vm.currentStep < 6
                  ? _c("h2", [
                      _vm._v("Hello" + _vm._s(_vm.currentUserName) + "!"),
                    ])
                  : _c("h2", [_vm._v("Thank you!")]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                [
                  _vm.currentStep == 0
                    ? _c("FormStep", {
                        attrs: {
                          step: _vm.currentStep,
                          "step-title":
                            "Contact details of the person applying",
                        },
                        on: {
                          nextStep: function ($event) {
                            _vm.currentStep += 1
                          },
                          prevStep: function ($event) {
                            _vm.currentStep -= 1
                          },
                        },
                        model: {
                          value: _vm.formData[_vm.steps[0]],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, _vm.steps[0], $$v)
                          },
                          expression: "formData[steps[0]]",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 1
                    ? _c("FormStep", {
                        attrs: {
                          step: _vm.currentStep,
                          applicant: _vm.formData.applicant,
                          "step-title": "Contact details of the Designer",
                        },
                        on: {
                          nextStep: function ($event) {
                            _vm.currentStep += 1
                          },
                          prevStep: function ($event) {
                            _vm.currentStep -= 1
                          },
                        },
                        model: {
                          value: _vm.formData[_vm.steps[1]],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, _vm.steps[1], $$v)
                          },
                          expression: "formData[steps[1]]",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 2
                    ? _c("FormStep", {
                        attrs: {
                          step: _vm.currentStep,
                          applicant: _vm.formData.applicant,
                          "step-title": "Contact details of the Manufacturer",
                        },
                        on: {
                          nextStep: function ($event) {
                            _vm.currentStep += 1
                          },
                          prevStep: function ($event) {
                            _vm.currentStep -= 1
                          },
                        },
                        model: {
                          value: _vm.formData[_vm.steps[2]],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, _vm.steps[2], $$v)
                          },
                          expression: "formData[steps[2]]",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 3
                    ? _c("FormStep", {
                        attrs: {
                          step: _vm.currentStep,
                          applicant: _vm.formData.applicant,
                          "step-title": "Product Details",
                        },
                        on: {
                          nextStep: function ($event) {
                            _vm.currentStep += 1
                          },
                          prevStep: function ($event) {
                            _vm.currentStep -= 1
                          },
                        },
                        model: {
                          value: _vm.formData[_vm.steps[3]],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, _vm.steps[3], $$v)
                          },
                          expression: "formData[steps[3]]",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 4
                    ? _c("FormStep", {
                        attrs: {
                          step: _vm.currentStep,
                          applicant: _vm.formData.applicant,
                          "step-title": "Billing Address",
                        },
                        on: {
                          nextStep: function ($event) {
                            _vm.currentStep += 1
                          },
                          prevStep: function ($event) {
                            _vm.currentStep -= 1
                          },
                        },
                        model: {
                          value: _vm.formData[_vm.steps[4]],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, _vm.steps[4], $$v)
                          },
                          expression: "formData[steps[4]]",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 5
                    ? _c("PaymentStep", {
                        attrs: {
                          step: _vm.currentStep,
                          billing: _vm.formData.billing,
                        },
                        on: { gosubmit: _vm.handleSubmitForm },
                        model: {
                          value: _vm.formData[_vm.steps[5]],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, _vm.steps[5], $$v)
                          },
                          expression: "formData[steps[5]]",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep == 6
                    ? _c("ThankyouStep", {
                        attrs: {
                          step: _vm.currentStep,
                          paymethod: _vm.formData.payment.method,
                          "form-id": _vm.submittedFormId,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }